module.exports = __webpack_public_path__ + "img/CellCycle-OPSCC_PMID37704757.63e13b26.png";